import { STORE_KEYS } from '../const/store-keys';
const getSelectedEnv = () => {
    if (typeof window !== 'undefined' &&
        typeof window.sessionStorage !== 'undefined') {
        return sessionStorage.getItem(STORE_KEYS.envKey) || 'qa';
    }
    return 'qa';
};
export default getSelectedEnv;
